export const EMAIL_OPTION_VALUES = {
    PRE_OPEN: 1,
    CONFIRM: 2,
    CUSTOM: 3,
}

export const emailItemList = [
    {
        name: "公演直前メール",
        description: "公演直前の案内メールを、予約者全員に送信します。",
        value: EMAIL_OPTION_VALUES.PRE_OPEN,
    },
    {
        name: "予約確定メール",
        description: "まだ予約確定メールを送っていない承認済予約者全員に、予約確定メールを送信します。",
        value: EMAIL_OPTION_VALUES.CONFIRM,
    },
    {
        name: "カスタムメール",
        description: "入力したメール文面を、選択した対象に一斉送信します。",
        value: EMAIL_OPTION_VALUES.CUSTOM,
    }
]

export const emailTargetList = [
    {
        name: "承認済の予約者",
        value: 1,
    },
    {
        name: "未承認の予約者",
        value: 2,
    },
]